import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiPostman,
  SiAnaconda,
  SiAndroidstudio,
  SiApollographql,
  SiGithub,
  SiIntellijidea,
  SiOverleaf,
  SiPhpmyadmin,
  SiPycharm,
  SiWebflow,
  SiVirtualbox,
  SiXilinx,
  SiTensorflow,
  SiPytorch,
  SiCypress,
  SiExpo,
  SiLodash,
  SiOpenssl,
  SiRedux,
  SiGithubactions,
  SiJest,
  SiNodemon,
  SiNumpy,
  SiOctave,
  SiPrettier,
  SiSelenium,
  SiSequelize,
  SiExpress,
  SiEslint,
  SiDotenv,
  SiJsonwebtokens,
  SiGithubpages,
  SiGenius,
  SiBootstrap,
  SiNextdotjs,
  SiRailway,
  SiEmbarcadero,
  SiWordpress,
  SiGitea,
  SiAnsible
} from "react-icons/si";
import {
  DiEclipse,
  DiSublime,
  DiDocker,
  DiNetbeans,
  DiNpm,
  DiPhotoshop,
  DiSqllite,
  DiStackoverflow,
  DiVisualstudio,
  DiNodejs,
} from "react-icons/di";
import {
  FaRaspberryPi,
  FaUnity,
  
  
} from "react-icons/fa";



function Toolstack() {
  return (
    <>
     <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
     <Col xs={4} md={2} className="tools-icons">
        <DiNetbeans />
        <div className="tool-tag">
          Netbeans
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiXilinx />
        <div className="tool-tag">
          Xilinx
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiIntellijidea />
        <div className="tool-tag">
          Intellijidea
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <DiEclipse />
        <div className="tool-tag">
          Eclipse
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <DiVisualstudio />
        <div className="tool-tag">
          Visual Studio Community
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiVisualstudiocode />
        <div className="tool-tag">
          Visual Studio
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiPycharm />
        <div className="tool-tag">
          PyCharm
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiEmbarcadero/>
        <div className="tool-tag">
          Embarcadero
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <FaUnity />
        <div className="tool-tag">
          Unity
        </div>
      </Col>  
      
      <Col xs={4} md={2} className="tools-icons">
        <SiAndroidstudio />
        <div className="tool-tag">
          Android Studio
        </div>
      </Col>
      
      
      <Col xs={4} md={2} className="tools-icons">
      <SiGenius/>
      <div className="tool-tag">
          Genius
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiOctave />
        <div className="tool-tag">
          Octave
        </div>
      </Col>

      <Row style={{ marginTop: "100px"}}>
        
      </Row>

      <Col xs={4} md={2} className="tools-icons">
        <SiOverleaf />
        <div className="tool-tag">
          Overleaf
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiGithub />
        <div className="tool-tag">
          Github
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiGithubactions />
        <div className="tool-tag">
          Github Actions
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiGithubpages />
        <div className="tool-tag">
          Github Pages
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <DiSqllite />
        <div className="tool-tag">
          Sql Lite
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiWebflow />
        <div className="tool-tag">
          Webflow
        </div>
      </Col>
     
      <Col xs={4} md={2} className="tools-icons">
        <DiStackoverflow />
        <div className="tool-tag">
          Stack Overflow
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <DiPhotoshop />
        <div className="tool-tag">
          Photoshop
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiPostman />
        <div className="tool-tag">
          Postman
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiAnaconda />
        <div className="tool-tag">
          Anaconda
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiWordpress />
        <div className="tool-tag">
          Wordpress
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiGitea />
        <div className="tool-tag">
          GiTea
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiAnsible />
        <div className="tool-tag">
          Ansible
        </div>
      </Col>
      
      <Row style={{marginTop: "100px"}}>
        
      </Row>
      
      <Col xs={4} md={2} className="tools-icons">
        <SiTensorflow />
        <div className="tool-tag">
          Tensorflow
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiPytorch />
        <div className="tool-tag">
          PyTorch
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiPhpmyadmin />
        <div className="tool-tag">
          Phpmyadmin
        </div>
      </Col>
      
      <Col xs={4} md={2} className="tools-icons">
        <SiApollographql />
        <div className="tool-tag">
          ApollographQL
        </div>
      </Col>
      


      
      <Col xs={4} md={2} className="tools-icons">
        <DiSublime />
        <div className="tool-tag">
          Sublime
        </div>
      </Col> 
      <Col xs={4} md={2} className="tools-icons">
      <SiBootstrap/>
      <div className="tool-tag">
          Bootstrap
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <DiNodejs />
        <div className="tool-tag">
          Node.js
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiNextdotjs />
        <div className="tool-tag">
          Next.js
        </div>
      </Col>
     
      <Col xs={4} md={2} className="tools-icons">
        <SiRailway />
        <div className="tool-tag">
          Railway
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <DiNpm/>
        <div className="tool-tag">
          Npm
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiVirtualbox />
        <div className="tool-tag">
          Virtualbox
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <DiDocker />
        <div className="tool-tag">
          Docker
        </div>
      </Col>

      

    </Row>

    <h1 className="project-heading">
    <strong className="purple">Libraries</strong> I use
    </h1>

    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tools-icons">
        <SiCypress/>
        <div className="tool-tag">
          CyPress
        </div>
      </Col>

      <Col xs={4} md={2} className="tools-icons">
        <SiLodash/>
        <div className="tool-tag">
          Lodash
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiOpenssl/>
        <div className="tool-tag">
          OpenSSL
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiRedux/>
        <div className="tool-tag">
          Redux
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <FaRaspberryPi/>
        <div className="tool-tag">
          RaspberryPi
        </div>
      </Col>
      
      <Col xs={4} md={2} className="tools-icons">
        <SiJest/>
        <div className="tool-tag">
          Jest
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiNodemon/>
        <div className="tool-tag">
          Nodemon
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiNumpy/>
        <div className="tool-tag">
          Numpy
        </div>
      </Col>

      <Col xs={4} md={2} className="tools-icons">
        <SiPrettier/>
        <div className="tool-tag">
          Prettier
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiSelenium/>
        <div className="tool-tag">
          Selenium
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiSequelize/>
        <div className="tool-tag">
          Sequelize
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiExpress/>
        <div className="tool-tag">
          Express
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiEslint/>
        <div className="tool-tag">
          EsLint
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiDotenv />
        <div className="tool-tag">
          Dotenv
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiJsonwebtokens/>
        <div className="tool-tag">
          Json webtokens
        </div>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiExpo/>
        <div className="tool-tag">
          Expo
        </div>
      </Col>
     
      
      
      

      
    </Row>
    </>
   


  );
}

export default Toolstack;
